/**
 * uiProgressButton.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2014, Codrops
 * http://www.codrops.com
 */

module.exports = UIProgressButton;

function getTransitionName () {
  var p = document.createElement('p').style;

  return 'transition' in p ? 'transitionend'
		: 'WebkitTransition' in p ? 'webkitTransitionEnd'
		: 'MozTransition' in p ? 'transitionend'
		: 'msTransition' in p ? 'MSTransitionEnd'
		: 'OTransition' in p ? 'oTransitionEnd'
		: null;
}

var transEndEventName = getTransitionName();

function extend (a, b) {
  for (var key in b) {
    if (b.hasOwnProperty(key))			{
      a[key] = b[key];
    }
  }

  return a;
}

function SVGEl (el) {
  this.el = el;
	// the path elements
  this.paths = [].slice.call(this.el.querySelectorAll('path'));
	// we will save both paths and its lengths in arrays
  this.pathsArr = new Array();
  this.lengthsArr = new Array();
  this._init();
}

SVGEl.prototype._init = function () {
  var self = this;
  this.paths.forEach(function (path, i) {
    self.pathsArr[i] = path;
    path.style.strokeDasharray = self.lengthsArr[i] = path.getTotalLength();
  });

	// undraw stroke
  this.draw(0);
};

// val in [0,1] : 0 - no stroke is visible, 1 - stroke is visible
SVGEl.prototype.draw = function (val) {
  for (var i = 0, len = this.pathsArr.length; i < len; ++i)		{
    this.pathsArr[i].style.strokeDashoffset = this.lengthsArr[i] * (1 - val);
  }
};

function UIProgressButton (el, options) {
  this.el = el;
  this.options = extend({}, this.options);
  extend(this.options, options);
  this._init();
}

UIProgressButton.prototype.options = {

};

UIProgressButton.prototype._init = function () {
  this.progressEl = new SVGEl(this.el.querySelector('svg.progress-circle'));
  this.successEl = new SVGEl(this.el.querySelector('svg.checkmark'));
  this.errorEl = new SVGEl(this.el.querySelector('svg.cross'));

  $(this.el).addClass('error plus');
  this.errorEl.draw(1);
};

UIProgressButton.prototype._submit = function () {
  $(this.el).addClass('loading').removeClass('plus');

  var self = this;
  var onEndBtnTransitionFn = function (ev) {
    if (transEndEventName) {
      if (ev.propertyName !== 'width') return false;
      this.removeEventListener(transEndEventName, onEndBtnTransitionFn);
    }

    this.setAttribute('disabled', '');

    if (typeof self.options.callback === 'function') {
      self.options.callback(self);
    } else {
      self.setProgress(1);
      self.stop();
    }
  };
};

// runs after the progress reaches 100%
UIProgressButton.prototype.stop = function (status) {
  var self = this;
  var endLoading = function () {
    self.progressEl.draw(0);

    if (typeof status === 'number') {
      var statusClass = status >= 0 ? 'success' : 'error';
      var statusEl = status >= 0 ? self.successEl : self.errorEl;

      statusEl.draw(1);
      $(self.el).addClass(statusClass);

      self.clear = function () {
        $(self.el).removeClass(statusClass);
        statusEl.draw(0);
      };
    }

    $(self.el).removeClass('loading error');
  };

  setTimeout(endLoading, 300);
};

UIProgressButton.prototype.clear = function () { };

UIProgressButton.prototype.setProgress = function (val) {
  this.progressEl.draw(val);
};
